import { GrowthBook } from "@growthbook/growthbook";
import { autoAttributesPlugin } from "@growthbook/growthbook/plugins";
import Cookies from "js-cookie";
import { UAParser } from "ua-parser-js";
import triggerClarity from "./lib/triggerClarity";

window.dataLayer = window.dataLayer || [];

window.trackEvent = (event) => {
  window.dataLayer.push({ event: 'trackEvent', ...event });
};

/**
 * E.g.
 * items: [
 *   { selector: "wistia-player", event: "gb_home_demo_video_click" },
 *   { selector: "#main-content header a[href*='/aanmelden']", event: "gb_home_signup_link_click" },
 * ]
 * feature: {
 *   experiment: { key: "gb_home_demo_video_click" },
 *   value: "gb_home_demo_video_click",
 * }
 */
window.trackElementClicks = (items, feature) => {
  items.forEach((item) => {
    const elements = document.querySelectorAll(item.selector);
    elements.forEach((element) => {
      element.addEventListener("click", () => {
        window.dataLayer.push({
          event: item.event,
          experimentId: feature?.experiment?.key,
          variationId: feature?.value,
        });
      });
    });
  });
};

function getGrowthbookDefaultAttributes() {
  const deviceInfo = new UAParser(window.navigator.userAgent).getResult();

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  return {
    url: location.href,
    path: location.pathname,
    host: location.host,
    query: location.search,
    pageTitle: window.pageProperties?.title || document.title,
    referrer: document.referrer,
    utmMedium: params.utm_medium || Cookies.get("utm_medium"),
    utmCampaign: params.utm_campaign || Cookies.get("utm_campaign"),
    utmSource: params.utm_source || Cookies.get("utm_source"),
    utmContent: params.utm_content || Cookies.get("utm_content"),
    utmTerm: params.utm_term || Cookies.get("utm_term"),
    loginClickCount: Number(Cookies.get("login_click_count") || 0),
    signupCount: Number(Cookies.get("signup_count") || 0),
    pageType: window.pageProperties?.page_type,
    relativeUrl: window.pageProperties?.relative_url,
    locale: window.pageProperties?.locale,
    deviceType: deviceInfo.device.type || "desktop",
    browser: deviceInfo.browser.name || "unknown",
    os: deviceInfo.os.name || "unknown",
    previewMode: params.previewMode == 'true',
  };
}

window.gbTrackEventWhenElementInViewport = (element, event) => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        window.trackEvent(event);
        observer.unobserve(entry.target);
      }
    });
  });
  observer.observe(element);
};

async function initializeGrowthbook() {
  if (Cookies.get("functional_cookie_consent") !== "1") {
    document.addEventListener('setCookiesCompleted', () => {
      initializeGrowthbook();
    });
    return;
  }

  const growthbook = new GrowthBook({
    apiHost: "https://cdn.growthbook.io",
    clientKey: "sdk-DKRVtx4XyiFcRPr",
    enableDevMode: true,
    trackingCallback: (experiment, result) => {
      window.dataLayer.push({
        event: "gb_experiment_viewed",
        experimentId: experiment.key,
        variationId: result.key,
      });

      triggerClarity({ experiment, variation: result });
    },
    attributes: {
      ...getGrowthbookDefaultAttributes(),
    },
    plugins: [
      autoAttributesPlugin({}),
    ],
  });

  // Wait for features to be available
  await growthbook.init({ streaming: true });

  window.gb = growthbook;
}

initializeGrowthbook();
